
import { Platforms } from "@/types/map";
import { Vue, Component, Emit, Prop, Ref } from "vue-property-decorator";
@Component({
  name: "MeasurementDiv",
})
export default class MeasurementDiv extends Vue {
  //地图配置
  @Prop({}) measurementTool!: any;
  @Prop({ default: "arcgis2d" }) platform!: Platforms;

  @Emit("tool-click")
  private MeasurementTool(type: "area" | "distance" | "direct-line" | "clear") {
    if (type == "clear") {
      this.measurementTool.clear();
    } else {
      this.measurementTool.activeTool = type;
    }
  }
}
